import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const AllgemeineSprechstundePage = () => {
  return (
    <Layout>
      <PageHero
        title="Allgemeine Sprechstunde: Zeit für Ihre Gesundheit"
        subtitle="Wir nehmen uns Zeit für Beratung, Diagnose und Therapieplanung – für Ihre langfristige Gesundheit."
        backgroundImage="/images/hausarzt.webp"
        ctaText="Termin vereinbaren"
      />

      <ContentSection
        title="Ihr vertrauensvoller Ansprechpartner"
        content="In unserer allgemeinen Sprechstunde widmen wir uns Ihren gesundheitlichen Anliegen, ganz gleich, ob es sich um chronische Erkrankungen, wiederkehrende Beschwerden oder allgemeine Gesundheitsfragen handelt. Wir nehmen uns die nötige Zeit, um Ihre Krankengeschichte zu erfassen, Sie umfassend zu beraten und gemeinsam mit Ihnen einen individuellen Therapieplan zu entwickeln."
        image="/images/hausarzt.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Hausarztberatung in Diez und Umgebung"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet Ihnen in der allgemeinen Sprechstunde eine persönliche und fundierte hausärztliche Betreuung, die auf Ihre individuellen Bedürfnisse zugeschnitten ist."
      />

      <CTASection
        title="Planen Sie Ihren nächsten Gesundheits-Check"
        subtitle="Vereinbaren Sie Ihren Wunschtermin online oder telefonisch."
        buttonText="Online-Termin buchen"
      />
    </Layout>
  );
};

export default AllgemeineSprechstundePage;
